var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateAdminImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7 36.6333H43.3666V29.9667H36.7V36.6333H11.5667V49.9667H18.2333V43.3H36.7V49.9667H43.3666V43.3H61.7V49.9667H68.3667V36.6333H66.7Z",
    fill: "#558223"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0333 23.3666C44.6357 23.3666 48.3666 19.6357 48.3666 15.0333C48.3666 10.4309 44.6357 6.69995 40.0333 6.69995C35.4309 6.69995 31.7 10.4309 31.7 15.0333C31.7 19.6357 35.4309 23.3666 40.0333 23.3666Z",
    fill: "#558223"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 73.3C19.5024 73.3 23.2333 69.569 23.2333 64.9666C23.2333 60.3643 19.5024 56.6333 14.9 56.6333C10.2976 56.6333 6.56665 60.3643 6.56665 64.9666C6.56665 69.569 10.2976 73.3 14.9 73.3Z",
    fill: "#558223"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0333 73.3C44.6357 73.3 48.3666 69.569 48.3666 64.9666C48.3666 60.3643 44.6357 56.6333 40.0333 56.6333C35.4309 56.6333 31.7 60.3643 31.7 64.9666C31.7 69.569 35.4309 73.3 40.0333 73.3Z",
    fill: "#558223"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0333 73.3C69.6357 73.3 73.3666 69.569 73.3666 64.9666C73.3666 60.3643 69.6357 56.6333 65.0333 56.6333C60.4309 56.6333 56.7 60.3643 56.7 64.9666C56.7 69.569 60.4309 73.3 65.0333 73.3Z",
    fill: "#558223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAdminImage);
export default __webpack_public_path__ + "static/media/corporateAdminImage.453a4f81c92594cf82f68fc2651d9ad0.svg";
export { ForwardRef as ReactComponent };